<template>
  <b-modal
    id="modal-1"
    title="Upload Patient Picture"
    v-model="editorShown"
    @cancel="onCancel"
    @hidden="onHidden"
    @ok="submitForm"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <vue-croppie
      ref="croppieRef"
      :enableOrientation="false"
      :boundary="{ width: 300, height: 300 }"
      :viewport="{ width: 200, height: 200, type: 'circle' }"
      :enableResize="false"
      @result="result"
    >
    </vue-croppie>
  </b-modal>
</template>

<script>
export default {
  name: "ImageCropper",
  props: ["image", "value"],
  data() {
    return {
      file: null,
      cropped: null
    };
  },
  mounted() {
    if (this.image) {
      this.loadImage();
    }
  },
  methods: {
    result(output) {
      this.cropped = output;
    },
    loadImage() {
      const reader = new FileReader();
      reader.onload = e => {
        this.$refs.croppieRef.bind({
          url: e.target.result
        });
      };
      reader.readAsDataURL(this.image);
    },
    submitForm() {
      let options = {
        type: "base64",
        size: { width: 200, height: 200 },
        format: "png"
      };
      this.$refs.croppieRef.result(options, output => {
        this.cropped = output;
        this.$emit("cropped", this.cropped);
      });
    },
    onCancel() {
      this.$emit("cancel");
    },
    onHidden() {}
  },
  computed: {
    editorShown: {
      get() {
        return !!this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    image() {
      if (this.image) {
        this.loadImage();
      }
    }
  }
};
</script>
